import { render, staticRenderFns } from "./tabButton.vue?vue&type=template&id=3a6f49a8&scoped=true"
import script from "./tabButton.vue?vue&type=script&lang=js"
export * from "./tabButton.vue?vue&type=script&lang=js"
import style0 from "./tabButton.vue?vue&type=style&index=0&id=3a6f49a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6f49a8",
  null
  
)

export default component.exports